module.exports = __webpack_public_path__ + "static/media/np.5350291f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/np.svg
// module id = 213
// module chunks = 0